import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import { loadState } from '../../../../store/localStorage';
import { setPage } from "../../BPOrder/state/actions";
import * as Path from './apiRoutes';
import $ from "jquery";
import { ROOT_URL } from "../../../../routes/constants";

const fetchDefault = (payload, iPageSize, iPageNum) => (dispatch) => {
    dispatch(Actions.changeRowSize(iPageSize));
    dispatch(setPage(iPageNum,`${ROOT_URL}/BusinessPartner`));
    return ApiService.post(Path.BUSINESS_PARTNER_GET_LIST + "/list/" + iPageSize + "/" + iPageNum, payload)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
            $(".defaultTable").scrollTop(0);
        }).catch(()=>{
        dispatch(Actions.setList([])); 
        })
};

const viewBusinessPartner = (payload) => () => {
    loadState();
    return ApiService.post(Path.BUSINESS_PARTNER_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const addBusinessPartner = (payload) => () => {
    return ApiService.add(Path.BUSINESS_PARTNER_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const editBusinessPartner = (payload) => () => {
    return ApiService.update(Path.BUSINESS_PARTNER_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const deleteBusinessPartner = (id, updUserCode) => () => {
    return ApiService.deleteByKey(Path.BUSINESS_PARTNER_GET_LIST, id, updUserCode)
        .then((response) => {
            return response.data;
        })
};

const checkLoginIdExists = (payload) => () => {
    return ApiService.post(Path.CHECK_BUSINESS_PARTNER, payload)
        .then((response) => {
            return response.data;
        })
}


export {
    fetchDefault,
    addBusinessPartner,
    editBusinessPartner,
    deleteBusinessPartner,
    viewBusinessPartner,
    checkLoginIdExists
};
